import store from '@/store'
import { SplitClient } from '@/plugins/split/SplitClient'
import { SVP_COMBINABLE_RLS } from '@/plugins/split/ActiveSplits'
import { GET_IS_AUTHENTICATED } from '@/store/get-types'
import { REFRESH_AUTH_TOKEN } from '@/store/action-types'
import { WALLET_LOGIN_ROUTE } from '@/router/routes/route-names'

export const walletRouterGuard = async (to, from, next) => {
  const isWalletRoute = Boolean(to.fullPath.match(/^\/wallet(?:\/*.*)?$/i))
  if (isWalletRoute) {
    const meta = to.meta || {}
    const allowUnauthenticated = Boolean(meta.allowUnauthenticated)
    await SplitClient.createApplicationClient()
    // if combinable RL application split is disabled, redirect to default route
    if (!SplitClient.isSplitEnabled(SVP_COMBINABLE_RLS)) {
      next({ path: '/' })
      return
    }
    // if the recipient is not authenticated, try to refresh their token
    if (!store.getters[GET_IS_AUTHENTICATED]) {
      await store.dispatch(REFRESH_AUTH_TOKEN)
      // if that didn't work, then they're not logged in; send them to the login screen
      if (!store.getters[GET_IS_AUTHENTICATED] && !allowUnauthenticated) {
        next({ name: WALLET_LOGIN_ROUTE })
        return
      }
    }
  }
  next()
}
